/* eslint-disable @typescript-eslint/no-explicit-any */
import VueRouter, { RawLocation } from 'vue-router';

export class Settings {
    router: VueRouter;
    public constructor(settings: any, router: VueRouter) {
        Object.assign(this, settings);
        this.router = router;
    }
    public absoluteUrl(url: string) {
        return window.location.origin + this.url(url);
    }
    public urlFromRoute(url: RawLocation) {
        return this.url(this.router.resolve(url).href);
    }
    public absoluteUrlFromRoute(url: RawLocation) {
        return this.absoluteUrl(this.router.resolve(url).href);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    authAudience: string;
    authDomain: string;
    authClientId: string;
    mainMenu: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean }>;
    landingMenu: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean; isDisabled: boolean, hubHidden: boolean }>;
    sideBar: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    penSwirl: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    sourceId: string;
    documentTypeId: string;
    landingPageModalExpDate: string;
    lockEnabled: string;
    lockPassword: string;

    questionId1User: string;
    answerId1UserHub: string;
    answerId1UserHCP: string;

    questionId2Age: string;
    answerId2AgeYes: string;
    answerId2AgeNo: string;

    questionId3Resident: string;
    answerId3ResidentYes: string;
    answerId3ResidentNo: string;

    questionId4FederalProgram: string;
    answerId4FederalProgramYes: string;
    answerId4FederalProgramNo: string;

    questionId5Prescription: string;
    answerId5PrescriptionYes: string;
    answerId5PrescriptionNo: string;

    questionIdTerms6: string;
    answerId6TermsYes: string;
    answerId6TermsNo: string;

    questionId7Acknowledge: string;
    answerId7Acknowledge: string;

    questionId8Signature: string;
    answerId8Signature: string;
}
